import React from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import './styles.scss';

const IgnitionStatusList: React.FC = () => {
  return (
    <div style={{ maxWidth: 250, padding: '10px', backgroundColor: '#495057' }}>
      <Typography
        variant="caption"
        style={{
          marginBottom: '6px',
          textAlign: 'center',
          display: 'block',
          color: 'var(--colorWhite)',
        }}
      >
        <b>Status</b>
      </Typography>

      <Typography component="div">
        <div className="row-legend">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: 'green',
            }}
          />
          <h6>ON</h6>
        </div>

        <div className="row-legend">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: 'yellow',
            }}
          />
          <h6>Idle</h6>
        </div>

        <div className="row-legend">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: 'red',
            }}
          />
          <h6>OFF</h6>
        </div>

        <div className="row-legend">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: 'gray',
            }}
          />
          <h6>3 wks+</h6>
        </div>

        <div className="row-legend">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: 'orange',
            }}
          />
          <h6>Not Tracked</h6>
        </div>

        <div className="row-legend">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: 'black',
            }}
          />
          <h6>Archive</h6>
        </div>

        <div className="row-legend">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: 'blue',
            }}
          />
          <h6>To Be Sold</h6>
        </div>

        <div className="row-legend">
          <div className="legend-battery-indicator" />
          <h6>Battery</h6>
        </div>
      </Typography>
    </div>
  );
};

export default IgnitionStatusList;